/**
 * Wrapper component for generic document tab content
 * Story 297: Agent research docs visible in UI as dynamic tabs
 *
 * Fetches document content via useStoryDocument and renders
 * GenericDocEditor (with sections) or EmptyDocState (empty).
 * This exists as a separate component because useStoryDocument
 * is a hook that must be called unconditionally.
 */

import { useStoryDocument } from '../../hooks/useStoryDocument';
import { GenericDocEditor } from './GenericDocEditor';
import { EmptyDocState } from './EmptyDocState';

interface GenericDocContentProps {
  projectSlug: string;
  storyId: string;
  docType: string;
  onSectionSelect?: (sectionKey: string) => void;
}

export function GenericDocContent({
  projectSlug,
  storyId,
  docType,
  onSectionSelect,
}: GenericDocContentProps) {
  const { data: doc, isLoading } = useStoryDocument(projectSlug, storyId, docType);

  if (isLoading) {
    return <p className="story-detail-panel__loading">Loading...</p>;
  }

  if (doc?.sections?.length) {
    return (
      <GenericDocEditor
        key={`${storyId}-${docType}`}
        projectSlug={projectSlug}
        storyId={storyId}
        docType={docType}
        sections={doc.sections}
        onSectionSelect={onSectionSelect}
      />
    );
  }

  return <EmptyDocState projectSlug={projectSlug} storyId={storyId} docType={docType} />;
}
